module.exports = __webpack_public_path__ + "static/media/accessibility.d000eeef.svg";